import { Divider } from "primereact/divider";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import {
  getProductListForXMOT,
  getProductThersholdForXMOT,
} from "../../../../../../services/xmotSurvey/survey";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { showToast } from "../../../../../../services/toast/toastService";
import { useNavigate } from "react-router-dom";
import handleError from "../../../../../../utils/handleError";
import { ProgressSpinner } from "primereact/progressspinner";
import { isEmptyCheck } from "../../../../../../utils/commonLogics";
import XmotLogicSetting from "./xmotInfoComponents/XmotLogicSetting";
const surveyTypeOptions = [
  { label: "Survey", value: "text" },
  { label: "Video", value: "video" },
  { label: "Audio", value: "audio" },
  { label: "Photo", value: "photo" },
];

const itemType = [
  { label: "Product", value: "product" },
  { label: "Device", value: "device" },
  { label: "Appliance", value: "appliance" },
];

const cameraType = [
  { label: "Back/Rear camera", value: 0 },
  { label: "Front/Selfie camera", value: 1 },
];

const photoType = [
  { label: "Photos with audio", value: "photo_audio_recorded" },
  { label: "Photos only", value: "photo_only" },
];

const XmotInfoStep = ({
  errors,
  categoryData,
  xmotFormData,
  handleXmotFormChange,
  finalStudyId,
  trigger_type,
  setIsThersholdErr,
  categoryId,
  mappedCategory,
  isEditMode,
  customRecruits,
  loading,
  isLocked,
  updateThresholdValuesInForm,
  isLogicSettingsError,
}) => {
  const {
    selectedCategory,
    seletedCustomRecruit,
    surveyName,
    surveyType,
    xmotItem,
    selectedDropdownValue,
    photoTypeOption,
    cameraTypeOption,
  } = xmotFormData;
  const { token, user } = useSelector((state) => state.auth);
  const [productOptions, setProductOptions] = useState([]);
  const [deviceOptions, setDeviceOptions] = useState([]);
  const [applianceOptions, setApplianceOptions] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const errorRef = useRef({});
  const logicPanel = useRef(null);
  const [duration, setDuration] = useState(
    xmotFormData?.trigger_session_seconds,
  );
  const [magnitude, setMagnitude] = useState(
    xmotFormData?.thresholdMagnitudeValue,
  );
  const [logicTriggerType, setLogicTriggerType] = useState(
    xmotFormData?.send_motion?.toString() || "1",
  );
  const [ThersholdData, setThresholdData] = useState({});
  const [sendAfterValue, setSendAfterValue] = useState(
    xmotFormData?.send_motion_seconds || 1,
  );
  const [sendAfterUnit, setSendAfterUnit] = useState(
    xmotFormData?.send_motion_unit?.toString() || "3",
  );
  useEffect(() => {
    setDuration(xmotFormData?.trigger_session_seconds);
    setMagnitude(xmotFormData?.thresholdMagnitudeValue);
    setLogicTriggerType(xmotFormData?.send_motion?.toString() || "1");
    setSendAfterValue(xmotFormData?.send_motion_seconds || 1);
    setSendAfterUnit(
      xmotFormData?.send_motion_unit === 0 ||
        xmotFormData?.send_motion_unit == null
        ? "3"
        : xmotFormData.send_motion_unit.toString(),
    );
  }, [xmotFormData]);
  const onApply = () => {
    handleXmotFormChange("trigger_session_seconds", parseInt(duration));
    handleXmotFormChange("thresholdMagnitudeValue", parseFloat(magnitude));
    handleXmotFormChange("send_motion", parseInt(logicTriggerType));
    if (logicTriggerType === "2") {
      handleXmotFormChange("send_motion_seconds", parseInt(sendAfterValue));
      handleXmotFormChange("send_motion_unit", parseInt(sendAfterUnit));
    } else {
      handleXmotFormChange("send_motion_seconds", null);
      handleXmotFormChange("send_motion_unit", null);
    }
    if (
      ThersholdData?.threshold?.usage_default_x === undefined ||
      ThersholdData?.threshold?.usage_default_x === null ||
      ThersholdData?.threshold?.usage_default_x === ""
    ) {
      handleXmotFormChange("trigger_usage_default_x", 0);
    } else {
      handleXmotFormChange(
        "trigger_usage_default_x",
        ThersholdData?.threshold?.usage_default_x,
      );
    }

    if (
      ThersholdData?.threshold?.usage_default_y === undefined ||
      ThersholdData?.threshold?.usage_default_y === null ||
      ThersholdData?.threshold?.usage_default_y === ""
    ) {
      handleXmotFormChange("trigger_usage_default_y", -1);
    } else {
      handleXmotFormChange(
        "trigger_usage_default_y",
        ThersholdData?.threshold?.usage_default_y,
      );
    }

    if (
      ThersholdData?.threshold?.usage_default_z === undefined ||
      ThersholdData?.threshold?.usage_default_z === null ||
      ThersholdData?.threshold?.usage_default_z === ""
    ) {
      handleXmotFormChange("trigger_usage_default_z", 0);
    } else {
      handleXmotFormChange(
        "trigger_usage_default_z",
        ThersholdData?.threshold?.usage_default_z,
      );
    }
    logicPanel.current.hide();
  };

  const getDropdownOptions = () => {
    switch (xmotItem) {
      case "product":
        return productOptions;
      case "device":
        return deviceOptions;
      case "appliance":
        return applianceOptions;
      default:
        return [];
    }
  };

  const CogIcon = () => {
    return (
      <span className="pi pi-cog me-2" style={{ color: "#D2D2D2" }}></span>
    );
  };

  const isItemTypeDisabled = (itemValue) => {
    const hasProducts = productOptions.length > 0;
    const hasDevices = deviceOptions.length > 0;
    const hasAppliances = applianceOptions.length > 0;

    switch (itemValue) {
      // case "product":
      //   return !hasProducts;
      case "device":
        return !hasDevices;
      case "appliance":
        return !hasAppliances;
      default:
        return false;
    }
  };

  useEffect(() => {
    getProductListData();

    if (customRecruits?.length === 1 && !isEditMode) {
      handleXmotFormChange("seletedCustomRecruit", customRecruits[0]);
    }
  }, []);

  useEffect(() => {
    const firstErrorKey =
      errors &&
      Object.keys(errors).length > 0 &&
      !isEmptyCheck(Object.values(errors)[0])
        ? Object.keys(errors)[0]
        : null;

    if (firstErrorKey) {
      const el = errorRef.current[firstErrorKey];
      if (el) {
        el?.scrollIntoView({ behavior: "smooth", block: "center" });
        el?.focus();
      }
    }
  }, [errors]);

  useEffect(() => {
    if (!isEditMode && !xmotItem) {
      const hasProducts = productOptions.length > 0;
      const hasDevices = deviceOptions.length > 0;
      const hasAppliances = applianceOptions.length > 0;

      // Auto-select if only one type has data
      if (hasProducts && !hasDevices && !hasAppliances) {
        handleXmotFormChange("xmotItem", "product");
      } else if (!hasProducts && hasDevices && !hasAppliances) {
        handleXmotFormChange("xmotItem", "device");
      } else if (!hasProducts && !hasDevices && hasAppliances) {
        handleXmotFormChange("xmotItem", "appliance");
      }
    }
  }, [productOptions, deviceOptions, applianceOptions, isEditMode, xmotItem]);

  const getProductListData = () => {
    const reqBody = {
      project_id: parseInt(finalStudyId),
      category_type: trigger_type,
      category_id: categoryId,
    };

    getProductListForXMOT(token, reqBody)
      .then((response) => {
        if (response.status === 200) {
          const productsData = response.data.data;
          setProductOptions(productsData?.product || []);
          setDeviceOptions(productsData?.device || []);
          setApplianceOptions(productsData?.appliance || []);
        }
      })
      .catch((error) => {
        console.error("Error fetching product listing:", error);
      });
  };

  const getProductThershold = (productId) => {
    const reqBody = {
      project_id: parseInt(finalStudyId),
      category_type: trigger_type,
      product_id: productId,
      trigger_product_type: xmotItem,
    };
    // setIsThersholdErr(false);
    getProductThersholdForXMOT(token, reqBody)
      .then((response) => {
        if (response.status === 200) {
          setThresholdData(response?.data);
          // move product active error on credit tab on publish button
          // if (response?.data?.msg) {
          //   setIsThersholdErr(true);
          //   showToast({
          //     severity: "error",
          //     summary: "Error",
          //     detail: response?.data?.msg,
          //     life: 4000,
          //   });
          // }
          if (response?.data?.threshold) {
            updateThresholdValuesInForm({
              trigger_usage_default_x:
                response?.data?.threshold?.usage_default_x || null,
              trigger_usage_default_y:
                response?.data?.threshold?.usage_default_y || null,
              trigger_usage_default_z:
                response?.data?.threshold?.usage_default_z || null,
              trigger_session_seconds:
                parseInt(response?.data?.threshold?.usage_min_time_threshold) ||
                null,
              thresholdMagnitudeValue:
                response?.data?.threshold?.usage_xyz_threshold_magnitude ||
                null,
              send_motion: xmotFormData?.send_motion || 1,
              send_motion_seconds: xmotFormData?.send_motion_seconds || null,
              send_motion_unit: xmotFormData?.send_motion_unit || null,
            });
            setDuration(response?.data?.threshold?.usage_min_time_threshold);
            setMagnitude(
              response?.data?.threshold?.usage_xyz_threshold_magnitude,
            );
          }
        }
      })
      .catch((error) => {
        // setIsThersholdErr(false);
        handleError(error, navigate, dispatch);
      });
  };

  return (
    <div className="mt-4">
      {loading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1000,
          }}
        >
          <ProgressSpinner
            style={{ width: "50px", height: "50px" }}
            strokeWidth="4"
            animationDuration="0.5s"
          />
        </div>
      )}
      {/* <div className="row mb-4">
          <div className="col-md-12">
              <label
                  htmlFor="survey_name"
                  className="form-label fw-600 d-block text-start dark-text"
              >
                  Select a Category:
              </label>
              <div className="mt-2">
                  <select
                      className={`form-select ${errors?.selectedCategory ? "error-input" : ""}`}
                      id="categoryDropdown"
                      onChange={(e) => handleXmotFormChange("selectedCategory", e.target.value)}
                      value={selectedCategory}
                  >
                      <option value="">Please select a category</option>
                      {categoryData?.map((item) => (
                          <option
                              key={item.category_id}
                              value={
                                  item.category_id +
                                  "-" +
                                  item.study_id +
                                  "-" +
                                  item.category_type
                              }
                          >
                              {item.category_name}
                          </option>
                      ))}
                  </select>

                  {errors?.selectedCategory ? (
                      <div className="text-start fs-14 text-danger">
                          {errors?.selectedCategory}
                      </div>
                  ) : (
                  ""
                  )}
              </div>
          </div>
      </div>
      <Divider /> */}

      <div className="row my-4">
        <div className="col-md-12">
          <div className="fw-600 text-start dark-text">
            Select a Custom Recruit
          </div>
          <div className="mt-2">
            <Dropdown
              value={seletedCustomRecruit}
              onChange={(e) => {
                handleXmotFormChange("seletedCustomRecruit", e.value);
              }}
              options={customRecruits}
              optionLabel="recruit_name"
              placeholder={`Please select a custom recruit`}
              className={`w-100 inputField fs-12 ${errors?.seletedCustomRecruit ? "error-input" : ""}`}
              disabled={isLocked}
            />

            {errors?.seletedCustomRecruit ? (
              <div
                className="text-start fs-14 text-danger"
                ref={(el) => (errorRef.current.seletedCustomRecruit = el)}
              >
                {errors?.seletedCustomRecruit}
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      </div>
      <Divider />

      <div className="row my-4">
        <div className="col-md-12">
          <label
            htmlFor="survey_name"
            className="form-label fw-600 d-block text-start dark-text"
          >
            XMOT Name <span className="fw-400">(Participant Facing)</span>
          </label>
          <InputText
            id="survey_name"
            className={`w-100 inputField ${errors?.surveyName ? "error-input" : ""}`}
            autoComplete="off"
            value={surveyName}
            onChange={(e) => handleXmotFormChange("surveyName", e.target.value)}
          />
          {errors?.surveyName ? (
            <div
              className="text-start fs-14 text-danger"
              ref={(el) => (errorRef.current.surveyName = el)}
            >
              {errors?.surveyName}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Divider />
      <div className="row my-4">
        <div className="col-md-12">
          <label className="form-label fw-600 d-block text-start dark-text">
            Xmot Type
          </label>
          <div className="d-flex flex-wrap gap-4 mt-2">
            {surveyTypeOptions.map((option) => (
              <div key={option.value} className="d-flex align-items-center">
                <RadioButton
                  inputId={option.value}
                  name="survey-type"
                  value={option.value}
                  onChange={(e) =>
                    handleXmotFormChange("surveyType", e.target.value)
                  }
                  checked={surveyType === option.value}
                  disabled={isLocked}
                />
                <label htmlFor={option.value} className="ms-2 fs-14 text-color">
                  {option.label}
                </label>
              </div>
            ))}
          </div>
          {errors?.surveyType ? (
            <div
              className="text-start fs-14 text-danger"
              ref={(el) => (errorRef.current.surveyType = el)}
            >
              {errors?.surveyType}
            </div>
          ) : (
            ""
          )}
        </div>
      </div>
      <Divider />
      {surveyType === "photo" && (
        <div className="row mb-3 mt-3">
          <div className="col-md-12 text-start">
            <div className="d-flex flex-wrap gap-4 mt-2">
              {photoType.map((option) => (
                <div key={option.value} className="d-flex align-items-center">
                  <RadioButton
                    inputId={option.value}
                    name="photo-type"
                    value={option.value}
                    onChange={(e) =>
                      handleXmotFormChange("photoTypeOption", e.value)
                    }
                    checked={photoTypeOption === option.value}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={option.value}
                    className="ms-2 fs-14 text-color"
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {["video", "photo"].includes(surveyType) && (
        <div className="row mb-3 mt-3">
          <div className="col-md-12 text-start">
            <label className="mb-1 fw-600 text-start text-color fs-14">
              Default Camera
            </label>
            <div className="d-flex flex-wrap gap-4 mt-2">
              {cameraType.map((option) => (
                <div key={option.value} className="d-flex align-items-center">
                  <RadioButton
                    inputId={option.value}
                    name="camera-type"
                    value={option.value}
                    onChange={(e) =>
                      handleXmotFormChange("cameraTypeOption", e.value)
                    }
                    checked={cameraTypeOption === option.value}
                    disabled={isLocked}
                  />
                  <label
                    htmlFor={option.value}
                    className="ms-2 fs-14 text-color"
                  >
                    {option.label}
                  </label>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      <Divider />
      <div className="row my-4">
        <div className="col-md-12">
          <label className="form-label fw-600 d-block text-start dark-text">
            XMOT Item
          </label>
          <div className="d-flex flex-wrap gap-4 mt-2">
            {itemType.map((option) => {
              const disabled = isItemTypeDisabled(option.value);
              return (
                <div key={option.value} className="d-flex align-items-center">
                  <RadioButton
                    inputId={option.value}
                    name="item-type"
                    value={option.value}
                    onChange={(e) => {
                      handleXmotFormChange("xmotItem", e.value);
                      handleXmotFormChange("selectedDropdownValue", null);
                    }}
                    checked={xmotItem === option.value}
                    disabled={disabled || isLocked}
                  />
                  <label
                    htmlFor={option.value}
                    className="ms-2 fs-14 text-color"
                  >
                    {option.label}
                  </label>
                </div>
              );
            })}
          </div>
          {errors?.xmotItem ? (
            <div
              className="text-start fs-14 text-danger"
              ref={(el) => (errorRef.current.xmotItem = el)}
            >
              {errors?.xmotItem}
            </div>
          ) : (
            ""
          )}
          {xmotItem && (
            <>
              <div className="mt-3">
                <Dropdown
                  value={selectedDropdownValue}
                  onChange={(e) => {
                    handleXmotFormChange("selectedDropdownValue", e.value);
                    getProductThershold(e.value);
                  }}
                  options={getDropdownOptions()}
                  optionLabel="name"
                  optionValue="id"
                  placeholder={`Select a ${xmotItem.charAt(0).toUpperCase() + xmotItem.slice(1)}`}
                  className={`w-100 inputField fs-12 ${errors?.selectedDropdownValue ? "error-input" : ""}`}
                  disabled={isLocked}
                />
              </div>
              {errors?.selectedDropdownValue ? (
                <div
                  className="text-start fs-14 text-danger"
                  ref={(el) => (errorRef.current.selectedDropdownValue = el)}
                >
                  {errors?.selectedDropdownValue}
                </div>
              ) : (
                ""
              )}
            </>
          )}
        </div>
        {user?.type === "superadmin" && selectedDropdownValue ? (
          <XmotLogicSetting
            thresholdData={ThersholdData || {}}
            magnitude={magnitude}
            setMagnitude={setMagnitude}
            duration={duration}
            setDuration={setDuration}
            logicTriggerType={logicTriggerType}
            setLogicTriggerType={setLogicTriggerType}
            sendAfterValue={sendAfterValue}
            setSendAfterValue={setSendAfterValue}
            sendAfterUnit={sendAfterUnit}
            setSendAfterUnit={setSendAfterUnit}
            buttonIcon={CogIcon}
            onApply={onApply}
            logicPanel={logicPanel}
            isLogicSettingsError={isLogicSettingsError}
          />
        ) : (
          ""
        )}
        {/* <p className="text-secondary fs-12 fw-600 text-start pt-2">
          Note: The sensor mapping file must be completed and uploaded in order
          for the dropdowns to populate
        </p> */}
      </div>
    </div>
  );
};

export default XmotInfoStep;
